/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useMemo, useState } from 'react';
import './style.scss';
import PropTypes from 'prop-types';

import {
  MaterialReactTable,
  useMaterialReactTable,
  getMRT_RowSelectionHandler,
} from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import { Box, darken, lighten, createTheme } from '@mui/material';

import ContasTable from './contasTable';
import CustosTable from './custosTable';

import MinimalTable from '../table/minimalTable';

import { ReactComponent as Close } from 'src/assets/icons/close.svg';
import { ReactComponent as Graph } from 'src/assets/icons/graph.svg';
import { ReactComponent as Board } from 'src/assets/icons/board.svg';
import { ReactComponent as Save } from 'src/assets/icons/check.svg';

import { constants } from 'buffer';
import { BorderRight } from '@mui/icons-material';
import { isValid } from 'src/services/auth';

import JSONPretty from 'react-json-pretty';
import RateiosTable from './rateiosTable';
import NvTable from './nvTable';
import showToast from '../toastyService';
var JSONPrettyMon = require('react-json-pretty/dist/monikai');

const customTheme = {
  main: 'color: #007e98; background:#f9f9f9;', // Fundo
  key: 'color: #004c5b;', // Chaves
  string: 'color: #c96800;', // Strings
  value: 'color: #b80900;', // Valores
  boolean: 'color: #99008c;', // Booleanos
  number: 'color: #4d0099;', // Números
};

export default function CentroDeCusto({
  onClose,
  Title,
  blocked,
  ordemCompra,
  fornecedor,
  data,
  saveFunction,
  origem,
}) {
  const [selectedRow1, setSelectedRow1] = useState();
  const [selectedRow2, setSelectedRow2] = useState();

  const [contasData, setContasData] = useState(() => [], []);
  const [selectedConta, setSelectedConta] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [selectedCcu, setSelectedCcu] = useState(0);
  const [custosData, setCustosData] = useState(() => [], []);

  const [valorBase, setValorBase] = useState(100);

  const [contasSoma, setContasSoma] = useState(0);
  const [contasDiferenca, setContasDiferenca] = useState(0);

  const [ccSoma, setCcSoma] = useState(0);
  const [ccDiferenca, setCcDiferenca] = useState(0);

  const [tipAca, setTipAca] = useState('');

  const [searchModo, setSearchModo] = useState(0);
  const [showSearch, setShowSearch] = useState(false);
  const [coluna, setColuna] = useState('');

  const [check, setCheck] = useState(false);
  const [checkRow, setCheckRow] = useState(false);
  const [checkDif, setCheckDif] = useState(false);

  const [erro, setErro] = useState('teste');

  const [showFinal, setShowFinal] = useState(false);

  const [showDelete1, setShowDelete1] = useState(false);
  const [showDelete2, setShowDelete2] = useState(false);

  const [finalJson, setFinalJson] = useState({});

  const [showGraph, setShowGraph] = useState(false);

  useEffect(() => {
    if (!data?.original?.rateio) return;

    let parsedData;
    try {
      parsedData = JSON.parse(data.original.rateio);
    } catch (err) {
      console.error('Erro ao parsear rateio:', err);
      return;
    }

    // Monta contasData
    const newContasData = parsedData.centroDeCusto.map((cc, index) => ({
      uid: index,
      codccu: cc.codccu,
      desc: cc.descta,
      valor: cc.perrat,
      dif: 0, // se quiser, pode calcular a diferença
    }));

    // Monta custosData alinhado com contasData
    const newCustosData = parsedData.centroDeCusto.map(
      (cc) =>
        cc.nv?.dados?.map((nvItem, idx) => ({
          uid: idx,
          conta: cc.codccu,
          nome: nvItem.nome,
          codnv: nvItem.codinv,
          valor: nvItem.perrat,
        })) || []
    );

    setContasData(newContasData);
    setCustosData(newCustosData);
  }, [data]);

  useEffect(() => {
    setFinalJson({
      soma: contasSoma,
      diferenca: contasDiferenca,
      centroDeCusto: contasData.map((conta) => ({
        id: conta.uid,
        codccu: conta.codccu,
        descta: conta.desc || '',
        perrat: conta.valor,

        nv: {
          soma: contasSoma,
          diferenca: contasDiferenca,
          dados: custosData
            .flat()
            .filter((custo) => custo?.conta === conta.codccu)
            .map((custo) => ({
              codinv: custo.codnv,
              nome: custo.nome,
              perrat: Number(custo.valor),
            })),
        },
      })),
    });

    if (contasData.length > 0) {
      setCheck(
        contasData.every((item) => {
          return isValid(item.codccu) && isValid(item.valor);
        })
      );
      setCheckDif(
        contasData.every((item) => {
          return item.dif === 0;
        })
      );
    } else {
      setCheck(false);
    }
  }, [valorBase, contasSoma, contasDiferenca, custosData, contasData]);

  const theme = createTheme({
    palette: {
      mode: 'light', // or 'dark'
      primary: {
        main: '#ff5722', // Change this to your preferred primary color
        contrastText: '#fff', // Text color on primary background
      },
    },
  });

  //light or dark green
  const baseBackgroundColor =
    theme.palette.mode === 'dark' ? 'rgba(3, 44, 43, 1)' : 'rgb(255, 255, 255)';

  const custoConfig = {
    initialState: { showGlobalFilter: true, density: 'compact' },

    layoutMode: 'grid',
    enableColumnOrdering: false,
    enableGlobalFilter: false,
    enableSorting: false,
    enablePagination: false,
    enableBottomToolbar: false,
    enableTopToolbar: false,
    enableColumnFilters: false,
    enableColumnActions: false,
    enableStickyHeader: true,
    enableRowPinning: false,
    enableRowSelection: false,
    enableSelectAll: false,
    enableBatchRowSelection: false,
    enableMultiRowSelection: false,
    rowPinningDisplayMode: 'top-and-bottom',
    enableFullScreenToggle: false,

    createDisplayMode: 'row', // ('modal', and 'custom' are also available)
    editDisplayMode: 'cell', // ('modal', 'row', 'cell', and 'custom' are also
    enableEditing: true,
    enableCellActions: true,
    positionActionsColumn: 'last',

    muiTableHeadCellProps: ({ column }) => ({
      sx: {
        marginBottom: '2rem',
        ...(column.id === 'mrt-row-select'
          ? { width: '100px', minWidth: '100px' }
          : {}),
      },
    }),
    muiTableBodyCellProps: ({ row, cell }) => ({
      onBlur: (e) => {
        if (selectedIndex === null || selectedIndex === undefined) {
          console.error('Index selecionado inválido.');
          return;
        }

        const validValue =
          e.target.value !== '' &&
          e.target.value !== '0' &&
          !isNaN(Number(e.target.value));

        setCustosData((prevData) => {
          const newData = [...prevData];

          if (newData[selectedIndex]) {
            newData[selectedIndex] = newData[selectedIndex].map(
              (item, index) =>
                index === row.index
                  ? {
                      ...item,
                      valor: Number(validValue ? e.target.value : item.valor),
                    }
                  : item
            );
          }

          return newData;
        });
        UpdateCC();
      },
      style: { cursor: 'pointer' },
      sx:
        cell.column.id === 'mrt-row-select'
          ? { width: '100px', minWidth: '100px' }
          : {},
    }),

    muiTableBodyRowProps: ({ row, staticRowIndex, table }) => ({
      onClick: (event) => {
        if (!row.getIsSelected()) {
          getMRT_RowSelectionHandler({ row, staticRowIndex, table })(event);
        }
      },
      sx: { cursor: 'pointer' },
    }),

    muiTableContainerProps: {
      sx: { height: '32vh', width: '100%' },
    },

    muiTableBodyProps: {
      sx: (theme) => ({
        '& tr:nth-of-type(odd):not([data-selected="true"]):not([data-pinned="true"]) > td':
          {
            backgroundColor: darken(baseBackgroundColor, 0.02),
          },
        '& tr:nth-of-type(odd):not([data-selected="true"]):not([data-pinned="true"]):hover > td':
          {
            backgroundColor: darken(baseBackgroundColor, 0.02),
          },
        '& tr:nth-of-type(even):not([data-selected="true"]):not([data-pinned="true"]) > td':
          {
            backgroundColor: lighten(baseBackgroundColor, 0.02),
          },
        '& tr:nth-of-type(even):not([data-selected="true"]):not([data-pinned="true"]):hover > td':
          {
            backgroundColor: darken(baseBackgroundColor, 0.02),
          },
      }),
    },
    mrtTheme: (theme) => ({
      baseBackgroundColor: baseBackgroundColor,
      draggingBorderColor: theme.palette.secondary.main,
    }),

    localization: MRT_Localization_PT_BR,
  };

  const contaConfig = {
    initialState: { showGlobalFilter: true, density: 'compact' },

    layoutMode: 'grid',
    enableColumnOrdering: false,
    enableGlobalFilter: false,
    enableSorting: false,
    enablePagination: false,
    enableBottomToolbar: false,
    enableTopToolbar: false,
    enableColumnFilters: false,
    enableColumnActions: false,
    enableStickyHeader: true,
    enableRowPinning: false,
    enableRowSelection: true,
    enableSelectAll: false,
    enableBatchRowSelection: false,
    enableMultiRowSelection: false,
    rowPinningDisplayMode: 'top-and-bottom',
    enableFullScreenToggle: false,
    enableEditing: true,

    createDisplayMode: 'row', // ('modal', and 'custom' are also available)
    editDisplayMode: 'cell', // ('modal', 'row', 'cell', and 'custom' are also
    enableCellActions: true,
    positionActionsColumn: 'last',

    onEditingRowSave: ({ row, values, table }) => {
      setContasData((prevData) =>
        prevData.map((item, index) =>
          item.uid === row.uid
            ? {
                ...item,
                valor: Number(values.valor),
              }
            : item
        )
      );
      UpdateContas();
      selecionarConta(values.valor);
      UpdateCC();
    },

    muiTableHeadCellProps: ({ column }) => ({
      sx: {
        marginBottom: '2rem',
        ...(column.id === 'mrt-row-select'
          ? { width: '100px', minWidth: '100px' }
          : {}),
      },
    }),
    muiTableBodyCellProps: ({ cell, row, table }) => ({
      onBlur: (e) => {
        if (!isValid(row.original.codccu) && cell.column.id !== 'codccu') {
          showToast('warning', 'Adicione o Código de Centro de Custos');
          table.setEditingCell(null);
          return;
        }

        const value = e.target.value;

        if (isValid(value)) {
          setContasData((prevData) =>
            prevData.map((item, index) =>
              index === row.index
                ? {
                    ...item,
                    valor: Number(value),
                  }
                : item
            )
          );
          UpdateContas();
          selecionarConta(value);
          UpdateCC();
        }
      },
      style: { cursor: 'pointer' },
      sx: {
        borderRight: '1px solid #f5f5f5',
        '&:hover': {
          backgroundColor: '#f0f0f0',
          borderBottom: '1px solid lightgray',
        },
        ...(cell.column.id === 'mrt-row-select'
          ? { width: '100px', minWidth: '100px', pointerEvents: 'none' }
          : {}),
      },
      onClick: (e) => {
        if (
          cell.column.id !== 'mrt-row-select' &&
          cell.column.id !== 'valor' &&
          cell.column.id !== 'delete' &&
          cell.column.id !== 'desc'
        ) {
          setSearchModo(0);
          setColuna(cell.column.id);
          setTipAca(cell.column.id);
          setSelectedIndex(row.original.uid);
          setShowSearch(true);
        }
      },
    }),

    muiTableBodyRowProps: ({ row, staticRowIndex, table }) => ({
      onClick: (event) => {
        const isDeleteColumn = event.target.closest('button'); // Verifica se o clique veio de um botão

        if (isDeleteColumn) {
          return;
        }

        if (!row.getIsSelected()) {
          getMRT_RowSelectionHandler({ row, staticRowIndex, table })(event);
        }

        selecionarConta(row.original.valor);
        setSelectedIndex(row.original.uid);
        setSelectedCcu(row.original.codccu);

        setCheckRow(
          isValid(row.original.codccu) && isValid(row.original.valor)
        );
      },
      sx: {
        cursor: 'pointer',
        backgroundColor:
          row.original.dif < 0 || row.original.valor > valorBase
            ? '#ed919f !important'
            : 'inherit',
      },
    }),

    muiTableContainerProps: {
      sx: { height: '32vh', width: '100%' },
    },

    localization: MRT_Localization_PT_BR,
  };

  function selecionarConta(valor) {
    setSelectedConta(valor);
  }

  function HandleContaAdd(row) {
    setContasData((prevData) => [
      ...prevData,
      {
        [coluna.toLowerCase()]: row.descta,
        id: row.codcta,
        valor: contasDiferenca,
        dif: contasDiferenca,
        uid: contasData.length,
      },
    ]);

    setShowSearch(false);
  }

  function HandleEditRow(row) {
    setContasData((prevData) =>
      prevData.map((item) => {
        if (item.uid === selectedIndex) {
          item[coluna] = `${row.codcta}`;
          item['desc'] = `${row.descta}`;
          item[`id${coluna}`] = row.codcta;
          setSelectedCcu(item.codccu);
        }
        return item;
      })
    );

    setCheckRow(
      contasData.every((item) => {
        return isValid(item.codccu) && isValid(item.valor);
      })
    );

    setShowSearch(false);
  }

  function UpdateContas() {
    const soma = contasData.reduce(
      (acc, item) => acc + (Number(item.valor) || 0),
      0
    );

    setContasSoma(soma);

    setContasDiferenca(valorBase - soma);
  }
  useEffect(() => {
    UpdateContas();
  }, [contasData, valorBase, contasDiferenca, contasSoma]);

  function HandleCCAdd(row) {
    setCustosData((prevData) => {
      const newData = [...prevData];

      if (!newData[selectedIndex]) {
        newData[selectedIndex] = [];
      }

      newData[selectedIndex] = [
        ...newData[selectedIndex],
        {
          conta: selectedCcu,
          nome: row.descta,
          valor: ccDiferenca,
          codnv: row.codcta,
          uid: custosData.length,
        },
      ];

      return newData;
    });

    setShowSearch(false);
  }
  function UpdateCC() {
    let soma = 0;

    if (custosData[selectedIndex] && Array.isArray(custosData[selectedIndex])) {
      soma = custosData[selectedIndex].reduce(
        (acc, item) => acc + (Number(item.valor) || 0),
        0
      );
    }

    setCcSoma(soma);

    setCcDiferenca(100 - (Number(ccSoma) || 0));
    setContasData((prevData) =>
      prevData.map((item, index) =>
        index === selectedIndex
          ? {
              ...item,
              dif: 100 - (Number(ccSoma) || 0),
            }
          : item
      )
    );
  }
  useEffect(() => {
    UpdateCC();
  }, [
    custosData,
    valorBase,
    ccDiferenca,
    ccSoma,
    selectedConta,
    selectedIndex,
  ]);

  const getTitle = (coluna) => {
    switch (coluna.toLowerCase()) {
      case 'ctared':
        return 'Conta Contábil';
      case 'ctafin':
        return 'Conta Financeira';
      case 'numprj':
        return 'Projeto';
      case 'codfpj':
        return 'Fase';
      default:
        return coluna.toLowerCase();
    }
  };

  const customTheme = {
    main: 'color: #007e98; background:#f9f9f9;', // Fundo
    key: 'color: #004c5b;', // Chaves
    string: 'color: #c96800;', // Strings
    value: 'color: #b80900;', // Valores
    boolean: 'color: #99008c;', // Booleanos
    number: 'color: #4d0099;', // Números
  };

  return (
    <div className={`rateios absoluteCenter ${blocked && 'blocked'}`}>
      {showGraph && (
        <div className="graph">
          <div className="gwrapper">
            {contasData?.map((item, index) => {
              const pastelHue = Math.floor(Math.random() * 360);
              const baseColor = `hsl(${pastelHue}, 70%, 85%)`;

              const maxValorConta = Math.max(
                ...contasData.map((c) => c.valor || 0)
              );

              return (
                <div
                  key={index}
                  className="gconta"
                  style={{
                    height: `${(item.valor / maxValorConta) * 100}%`,
                    width: `${100 / contasData.length}%`,
                    backgroundColor: baseColor,
                  }}
                >
                  <div className="gheader">
                    <div>
                      <span style={{ backgroundColor: baseColor }}>
                        {item?.desc} | Cod. {item?.codccu} | Valor:{' '}
                        {item?.valor}%
                      </span>
                    </div>
                  </div>
                  {custosData[index]?.map((custo, cindex) => (
                    <div
                      key={cindex}
                      className="gcusto"
                      style={{
                        height: `${custo?.valor}%`,
                      }}
                    >
                      <div
                        className="bg"
                        style={{
                          backgroundColor: `hsl(0, 0%, ${100 - custo.valor}%)`,
                        }}
                      />
                      <span
                        style={{
                          backgroundColor: baseColor,
                        }}
                      >
                        {custo.codnv} <b> {custo.nome} </b>
                        <span>Valor: {custo.valor}%</span>
                      </span>
                    </div>
                  ))}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {(showDelete1 || showDelete2) && <div className="fade" />}
      {showDelete1 && (
        <div className="popup absoluteCenter mainShadow">
          <h3>Deletar {selectedRow1.original.desc}</h3>
          <div>
            <button
              onClick={() => {
                setSelectedRow1({});
                setShowDelete1(false);
              }}
              className="mainButton yellow"
            >
              Cancelar
            </button>
            <button
              disabled={!isValid(selectedRow1)}
              className="mainButton turquoise"
              onClick={() => {
                if (selectedRow1.original.uid === selectedIndex) {
                  setSelectedIndex(-1);
                }
                setContasData((prev) =>
                  prev.filter((item, index) => index !== selectedRow1.index)
                );
                setShowDelete1(false);
              }}
            >
              Confirmar
            </button>
          </div>
        </div>
      )}

      {showDelete2 && (
        <div className="popup absoluteCenter mainShadow">
          <h3>Deletar {selectedRow2.original.nome}</h3>
          <div>
            <button
              onClick={() => {
                setShowDelete2(false);
              }}
              className="mainButton yellow"
            >
              Cancelar
            </button>
            <button
              disabled={!isValid(selectedRow2)}
              className="mainButton turquoise"
              onClick={() => {
                setCustosData((prev) =>
                  prev.map((group) =>
                    Array.isArray(group)
                      ? group.filter(
                          (item, index) => index !== selectedRow2.index
                        )
                      : group
                  )
                );
                setShowDelete2(false);
              }}
            >
              Confirmar
            </button>
          </div>
        </div>
      )}

      <div className={`debug ${showFinal && 'active'}`}>
        <JSONPretty
          id="json-pretty"
          data={JSON.stringify(finalJson)}
          theme={customTheme}
        ></JSONPretty>
      </div>

      {showSearch && (
        <div className="modal absoluteCenter consultaModal">
          <MinimalTable
            Title={getTitle(coluna)}
            porta={'GetConsRateio'}
            onClose={() => setShowSearch(false)}
            SetSearch={(row) => {
              searchModo === 0 ? HandleEditRow(row) : HandleCCAdd(row);
            }}
            aditionalParams={{ tipAca: tipAca }}
            Filtro={finalJson}
            SelectedItem={selectedCcu}
          />
        </div>
      )}

      <div className="rateioContent">
        <div className="header">
          <div className="title">
            <h2>Rateios</h2>
            <div className="infoWrapper">
              <span className="column">
                <p className="info">
                  Ordem de Compra: <b>{ordemCompra}</b> | Fornecedor:{' '}
                  <b>{fornecedor}</b>
                </p>
              </span>
            </div>
            <button onClick={() => onClose()}>
              <Close />
            </button>
          </div>
          <div className="Title">Centro de Custos</div>
          <button
            className={`rowAdd ${blocked && 'hide'}`}
            onClick={
              () => {
                HandleContaAdd({});
              } /*HandleContaAdd()*/
            }
            disabled={
              !(
                (contasDiferenca > 0 && check) ||
                (contasData.length < 1 && contasDiferenca > 0)
              )
            }
          >
            <span>Adicionar</span>
            {!(
              (contasDiferenca > 0 && check) ||
              (contasData.length < 1 && contasDiferenca > 0)
            ) && (
              <div className="erroRat">
                <span>
                  {contasDiferenca <= 0
                    ? 'Não há valor disponível'
                    : !check
                      ? 'Linha inválida'
                      : !checkDif
                        ? 'Valor não rateado'
                        : ''}
                </span>
              </div>
            )}
          </button>
        </div>
        <Box
          sx={{
            height: 'auto',
            width: '100%',
            position: 'relative',
            border: '1px solid lightgray',
          }}
        >
          <RateiosTable
            config={contaConfig}
            data={contasData}
            setSearch={() => setShowSearch(true)}
            setColuna={(col) => setColuna(col)}
            handleDelete={(row) => {
              setSelectedRow1(row);
              setShowDelete1(true);
              /*setContasData((prev) =>
                prev.filter((item) => item.uid !== row.original.uid)
              );*/
            }}
          />
        </Box>
        <div className="infoWrapper">
          <span className={`column ${contasDiferenca > 0 && 'difErro'}`}>
            <p className="info">Diferença:</p>
          </span>
          <span className={`column ${contasDiferenca > 0 && 'difErro'}`}>
            <p className="info">{contasDiferenca}%</p>
          </span>
        </div>
        <div className="header">
          <div className="Title">NV</div>
          <button
            className={`rowAdd ${blocked && 'hide'}`}
            onClick={() => {
              setSearchModo(1);
              setTipAca('codinv');
              setShowSearch(true);
            }} /*HandleContaAdd()*/
            disabled={!checkRow || !(ccDiferenca > 0)}
          >
            <span>Adicionar</span>
            {(!checkRow || !(ccDiferenca > 0)) && (
              <div className="erroRat">
                <span>
                  {selectedIndex === -1
                    ? 'Nenhuma linha selecionada'
                    : !checkRow
                      ? 'Linha inválida'
                      : ccDiferenca <= 0
                        ? 'Não há valor disponível'
                        : ''}
                </span>
              </div>
            )}
          </button>
        </div>
        <Box
          sx={{
            height: 'auto',
            width: '100%',
            position: 'relative',
            border: '1px solid lightgray',
          }}
        >
          <NvTable
            config={custoConfig}
            data={custosData[selectedIndex] || []}
            handleDelete={(row) => {
              setSelectedRow2(row);
              setShowDelete2(true);

              /*setCustosData((prev) =>
                prev.map((group) =>
                  Array.isArray(group)
                    ? group.filter((item) => item.uid !== row.original.uid)
                    : group
                )
              );*/
            }}
          />
        </Box>
        <div className="infoWrapper">
          {selectedIndex !== -1 && (
            <span className={`column ${ccDiferenca > 0 && 'difErro'}`}>
              <p className="info">Diferença:</p>
            </span>
          )}
          {selectedIndex !== -1 && (
            <span className={`column ${ccDiferenca > 0 && 'difErro'}`}>
              <p className="info">{ccDiferenca}%</p>
            </span>
          )}

          <div className="rateioSalvar">
            {/*<button
              className="mainButton turquoise"
              onClick={() => {
                setShowFinal(true);
              }}
              //disabled={!check || !checkDif}
            >
              Mostrar
            </button>
            <button
              className="mainButton red"
              onClick={() => {
                setShowFinal(false);
              }}
              //disabled={!check || !checkDif}
            >
              Esconder
            </button>*/}

            <div className="row">
              <span>
                {contasData.length < 1
                  ? 'Não há conteúdo'
                  : !check
                    ? 'Existem linhas inválidas'
                    : !checkDif
                      ? 'Existem valores não rateados'
                      : ''}
              </span>

              <button
                className="mainButton yellow"
                onClick={() => {
                  setShowGraph((prev) => !prev);
                  console.log(custosData);
                }}
              >
                {showGraph ? <Board /> : <Graph />}
                {showGraph ? 'Tabela' : 'Gráfico'}
              </button>

              <button
                className="mainButton turquoise"
                onClick={() => {
                  saveFunction(origem, { rateio: JSON.stringify(finalJson) });
                }}
                disabled={!check /*|| !checkDif*/}
              >
                <Save />
                Salvar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

CentroDeCusto.propTypes = {
  onClose: PropTypes.func.isRequired,
  Title: PropTypes.string,
};
